import { useState, useEffect } from "react";
import {
  SubmitBtn,
  ActionSection,
  ScrollableContent,
  SideCancelBtn,
} from "../../Styles/InputStyles";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import "react-dropdown/style.css";

const FilterModal = ({
  onApplyFilter,
  handleClose,
  setSelectedFilter,
  selectedFilter,
  activeFilters,
}) => {
  const [height, setHeight] = useState(window.innerHeight);

  const [localSelectedFilters, setLocalSelectedFilters] = useState({
    1: null,
    2: null,
    3: null,
    4: null
  });

  const filterGroups = [
    {
      title: "Gender Preference",
      type: 1,
      options: [
        { value: "1", label: "Male" },
        { value: "2", label: "Female" },
        { value: "3", label: "Co-Living" },
      ],
    },
    {
      title: "Amenities",
      type: 2,
      options: [
        { value: "AC", label: "AC" },
        { value: "Attached Bathroom", label: "Attached Bathroom" },
        { value: "Balcony", label: "Balcony" },
      ],
    },
    {
      title: "Sharing Type",
      type: 3,
      options: [
        { value: "1", label: "Single Sharing" },
        { value: "2", label: "Double Sharing" },
        { value: "3", label: "Triple Sharing" },
        { value: "4", label: "3+" },
      ],
    },
    {
      title: "Vacancy Type",
      type: 4,
      options: [
        // { value: "null", label: "All" },
        { value: "1", label: "Fully Vacant" },
        { value: "0", label: "Partially Vacant" },
        { value: "2", label: "Dormant Beds" },
      ],
    },
  ];

  useEffect(() => {
    setLocalSelectedFilters({
      1: activeFilters?.tenantPreference
        ? {
          type: 1,
          value: String(activeFilters.tenantPreference),
          label:
            activeFilters.tenantPreference === 1
              ? "Male"
              : activeFilters.tenantPreference === 2
                ? "Female"
                : "Both",
        }
        : null,

      2: activeFilters?.amenities?.map((amenity) => ({
        type: 2,
        value: amenity,
        label: amenity,
      })) || [],

      3: activeFilters?.roomSharing
        ? {
          type: 3,
          value:
            activeFilters.roomSharing === "3+"
              ? "4"
              : String(activeFilters.roomSharing),
        }
        : null,
      // 4: activeFilters?.dormant
      //   ? { type: 4, value: "2", label: "Dormant Beds" }
      //   : null,
      4: activeFilters?.vacancyType
        ? {
          type: 4,
          value: String(activeFilters.vacancyType),
          label:
            activeFilters.vacancyType === "1"
              ? "Fully Vacant"
              : activeFilters.vacancyType === "0"
                ? "Partially Vacant"
                : "Dormant Beds",
        }
        : null,
    });
  }, [activeFilters]);

  const handleFilterSelect = (groupType, option) => {
    if (groupType === 4 && option.value === "null") {
      setLocalSelectedFilters((prev) => ({ ...prev, 4: null }));
      return;
    }
    setLocalSelectedFilters((prev) => {
      if (groupType === 2) {
        const currentAmenities = prev[2] || [];
        const exists = currentAmenities.some(
          (item) => item.value === option.value
        );

        if (exists) {
          return {
            ...prev,
            2: currentAmenities.filter(
              (item) => item.value !== option.value
            ),
          };
        }

        return {
          ...prev,
          2: [
            ...currentAmenities,
            {
              type: 2,
              value: option.value,
              label: option.label,
            },
          ],
        };
      }

      const current = prev[groupType];

      if (current?.value === option.value) {
        return {
          ...prev,
          [groupType]: null,
        };
      }

      return {
        ...prev,
        [groupType]: {
          type: groupType,
          value: option.value,
          label: option.label,
        },
      };
    });
  };

  const handleApplyFilter = () => {
    const filtersToApply = [];

    Object.values(localSelectedFilters).forEach((filter) => {
      if (!filter) return;

      if (Array.isArray(filter)) {
        filtersToApply.push(...filter);
      } else if (filter.value !== "null") {
        filtersToApply.push(filter);
      }
      // else {
      //     filtersToApply.push(filter);
      //   }
    });

    if (filtersToApply.length > 0) {
      onApplyFilter(filtersToApply);
      // setSelectedFilter(filtersToApply);
    } else {
      toast.error("Please select at least one filter before applying.");
    }
  };
  const isOptionSelected = (groupType, optionValue) => {
    if (groupType === 2) {
      return (
        localSelectedFilters[2]?.some(
          (item) => item.value === optionValue
        ) || false
      );
    }

    return localSelectedFilters[groupType]?.value === optionValue;
  };

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Header>
        <h1 className="text-lg font-medium text-white">Filters</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <div className="custom-scrollbar flex h-full flex-col justify-between px-4">
        <ScrollableContent className="max-h-[calc(100vh-140px)] overflow-y-auto mt-4">
          {filterGroups.map((group) => (
            <FilterGroup key={group.title}>
              <FilterTitle>{group.title}</FilterTitle>

              <FilterOptions>
                {group.options.map((option) => {
                  const isActive = isOptionSelected(
                    group.type,
                    option.value
                  );

                  return (
                    <FilterOption
                      key={option.value}
                      active={isActive}
                      onClick={() =>
                        handleFilterSelect(group.type, option)
                      }
                    >
                      {option.label}
                    </FilterOption>
                  );
                })}
              </FilterOptions>
            </FilterGroup>
          ))}
        </ScrollableContent>

        <ActionSection>
          <SideCancelBtn type="button" onClick={handleClose}>
            Cancel
          </SideCancelBtn>

          <SubmitBtn type="button" onClick={handleApplyFilter}>
            Apply Filter
          </SubmitBtn>
        </ActionSection>
      </div>
    </Container>
  );
};

const Container = tw.div`
  bg-white w-full h-full flex flex-col relative
`;

const Header = tw.div`
  flex items-center justify-between bg-primary-color py-4 px-4
`;

const FilterGroup = tw.div`
  mb-4 p-4 bg-gray-50 rounded-lg
`;

const FilterTitle = tw.h3`
  text-md font-medium text-gray-800 mb-2
`;

const FilterOptions = tw.div`
  flex flex-wrap gap-2 mt-2
`;

const FilterOption = tw.button`
  px-3 py-1.5 text-sm rounded-full border transition-colors duration-200
  ${({ active }) =>
    active
      ? "border-primary-color bg-primary-color text-white"
      : "bg-white border-gray-300 text-gray-700 hover:border-gray-400"}
`;

export default FilterModal;